<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-textarea ttLabel="travelbill_reject_messagetext" [(ttModel)]="edit.travelbill_reject_messagetext"></tt-textarea>
        <tt-button-save ttText="travelbillreject_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
